export const IconCalendar: {
  name: 'icon_calendar-29b8803d07b8'
} = {
  name: 'icon_calendar-29b8803d07b8'
}
